import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
host.plugins.register({
    // #region Vars
    name: "288a.web.sentry",
    // #endregion
    // #region Startup
    startup() {
        // #region Sentry
        if (host.config.loggingUrl) {
            Sentry.init({
                Vue: this.$host.app,
                dsn: host.config.loggingUrl,
                release: 'webportal@1.0',
                integrations: [new Integrations.BrowserTracing()],
                tracesSampleRate: 0.1,
                tracingOptions: {
                    trackComponents: false,
                },
            });
        }
        // #endregion
    }
    // #endregion
});
